
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"#F5F5F5","d":"M6.483 2h11.034v20H6.483z"}}),_c('path',{attrs:{"fill":"red","d":"M6.483 2v20H2V2h4.483zM22 2v20h-4.483V2H22zM12 7.949l.56 1.05a.348.348 0 00.318.182l.078-.012.532-.146-.347 2.02c-.027.152.14.249.257.176l.04-.036.814-.952.083.375c.038.17.195.282.361.27l.072-.013.866-.252-.152 1.145a.343.343 0 00.126.315l.061.039.47.235-2.046 1.17a.497.497 0 00-.244.519l.024.087.175.468-1.754-.15a.163.163 0 00-.171.12l-.006.047.055 1.877h-.344l.055-1.877a.163.163 0 00-.13-.164l-.047-.003-1.753.15.175-.468a.498.498 0 00-.146-.555l-.074-.052-2.046-1.17.47-.234a.347.347 0 00.19-.282l-.003-.072-.153-1.145.867.252a.347.347 0 00.41-.188l.023-.069.083-.375.813.952c.1.117.281.05.3-.086l-.002-.054-.347-2.02.532.146a.344.344 0 00.35-.106l.045-.065.56-1.05z"}})])])
          )
        }
      }
    